import React from "react";
import DocumentIcon from "../../../assets/TaskModalIcons/document-text";
import DownloadIcon from "../../../assets/TaskModalIcons/DownloadIcon";
import Close from "../../../assets/icons/Close";
import {
  AttachmentData,
  AttachmentDownload,
  AttachmentName,
  AttachmentNameAndSize,
  AttachmentSize,
  Container,
  DocIcon,
  IconButtons,
} from "./styles";

const Attachment = ({ AnexName, AnexSize, DownloadLink, DeleteAttachment }) => {
  return (
    <Container>
      <AttachmentData>
        <DocIcon>
          <DocumentIcon />
        </DocIcon>
        <AttachmentNameAndSize>
          <AttachmentName>{AnexName}</AttachmentName>
          <AttachmentSize>Tamanho:{AnexSize}</AttachmentSize>
        </AttachmentNameAndSize>
      </AttachmentData>

      <IconButtons>
        <AttachmentDownload
          href={DownloadLink}
          target="_blank"
          download={AnexName}
        >
          <DownloadIcon height="1.4rem" width="1.5rem" />
        </AttachmentDownload>

        <Close
          style={{ cursor: "pointer" }}
          onClick={DeleteAttachment}
          width={"0.9rem"}
        />
      </IconButtons>
    </Container>
  );
};

export default Attachment;
